import {getAppOrigin} from '@salesforce/pwa-kit-react-sdk/utils/url'
import fetch from 'node-fetch'

export class API {
    constructor({host, siteId, isProduction, env}) {
        this.host = host
        this.siteId = siteId
        this.isProduction = isProduction
        this.env = env
    }

    _buildBody(params) {
        const instanceType_prd = 'prd'
        const instanceType_sbx = 'sbx'

        const body = {...params}

        // The first part of the siteId is the realm
        if (this.siteId) {
            body.realm = this.siteId.split('-')[0]
        }

        if (this.isProduction) {
            body.instanceType = instanceType_prd
        } else {
            body.instanceType = instanceType_sbx
        }

        return body
    }

    async siteCustomApi(endpoint, method, body, type, version, header, token) {
        const headers = {
            'Content-Type': 'application/json',
            authorization: `Bearer ${token}`,
        }

        if (body) {
            body = this._buildBody(body)
        }

        let response = await fetch(
            `${getAppOrigin()}/mobify/proxy/api/custom/${type}/${version}/${endpoint}`,
            {
                method: method,
                headers,
                ...(body && {
                    body: JSON.stringify(body),
                }),
            },
        )

        if (!response?.ok || response.status === 204) {
            return {}
        }

        return await response.json()
    }

    async siteCustomObjectApi(endpoint, method, body, version, header, token) {
        const headers = {
            'Content-Type': 'application/json',
            authorization: `Bearer ${token}`,
        }

        if (body) {
            body = this._buildBody(body)
        }

        let response = await fetch(
            `${getAppOrigin()}/mobify/proxy/api/custom-object/shopper-custom-objects/${version}/${endpoint}`,
            {
                method: method,
                headers,
                ...(body && {
                    body: JSON.stringify(body),
                }),
            },
        )

        if (!response?.ok || response.status === 204) {
            return {}
        }

        return await response.json()
    }

    async getCustomObject(customObjectType, key, token) {
        const endpoint = `organizations/${this.env}/custom-objects/${customObjectType}/${key}?siteId=${this.siteId}`
        const method = 'GET'
        const body = null
        const version = 'v1'
        const header = ''

        return this.siteCustomObjectApi(endpoint, method, body, version, header, token)
    }

    async deleteCustomer(token, customerId) {
        const endpoint = `organizations/${this.env}/customers/${customerId}?siteId=${this.siteId}`
        const method = 'DELETE'
        const body = null
        const version = 'v1'
        const header = ''

        return this.siteCustomApi(endpoint, method, body, 'delete-customer', version, header, token)
    }
}
